import RadioButton from "./RadioButton";
import block from "bem-css-modules";

import s from './RadioGroup.module.scss';
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";

const b = block(s);

const RadioGroup = ({items, onChange, onBlur, value, error, name, defaultFirst = true, mix}) => {
    const {t} = useTranslation('common');

    let selectedValue = value;
    if (defaultFirst && items?.length > 0 && !(items.some(item => `${selectedValue}` === `${item.id}`))) {
        selectedValue = items[0].id;
    }

    useEffect(() => {
        onChange({
            type: 'change',
            target: {
                name,
                value: selectedValue
            }
        });
    }, [selectedValue, name, onChange]);

    return <>
        <div className={classNames(b(), mix)}>
            {items?.map(item =>
                <RadioButton
                    name={name}
                    key={`key-${item.id}`}
                    item={item}
                    onChange={onChange}
                    onBlur={onBlur}
                    selectedValue={selectedValue}/>
            )}
        </div>
        {error && <span className={b('error')}>{error?.type ? t(`errors.${error?.type}`) : ""}</span>}
    </>
}

export default RadioGroup;